import React from 'react';

// THE LAYER MARKS — one figure in three readings, the realm's rings taken apart:
//   internal  ●   you, at the centre
//   gates     ◎   you inside the ring you set
//   external  ○·  something beyond the ring
// Drawn in currentColor; a zone's hue comes from --nx-zone-<id> (Layout.css).
const FIGURES = {
    internal: <circle cx="9" cy="8" r="4" fill="currentColor" />,
    gates: (
        <>
            <circle cx="9" cy="8" r="6.25" fill="none" stroke="currentColor" strokeWidth="1.5" />
            <circle cx="9" cy="8" r="2.5" fill="currentColor" />
        </>
    ),
    external: (
        <>
            <circle cx="6.5" cy="8" r="5.25" fill="none" stroke="currentColor" strokeWidth="1.5" />
            <circle cx="15.25" cy="8" r="2.25" fill="currentColor" />
        </>
    ),
};

export function ZoneMark({ zone, size = 14, className = '', title }) {
    if (!FIGURES[zone]) return null;
    return (
        <svg
            className={`nx-zone-mark ${className}`}
            data-zone={zone}
            width={Math.round(size * 18 / 16)}
            height={size}
            viewBox="0 0 18 16"
            aria-hidden={title ? undefined : 'true'}
            role={title ? 'img' : undefined}
        >
            {title && <title>{title}</title>}
            {FIGURES[zone]}
        </svg>
    );
}
